<template>
  <div class="auth">
    <mq-layout mq="small2+">
      <img class="blocks-bg" src="../img/blocks.svg" />
    </mq-layout>
    <div class="container">
      <div class="row justify-content-center" style="height: 100%">
        <div class="col-12" style="height: 100%">
          <nav class="row justify-content-center">
            <div class="mx-auto">
              <logo-component color="rgba(0, 0, 0, 0.9)" height="34px" />
            </div>
          </nav>
          <section>
            <div class="mx-auto view-container">
              <transition name="fade" mode="out-in">
                <router-view />
              </transition>
            </div>
          </section>
          <ul class="footer-links">
            <li>
              <a href="https://inscribe.ai/about"> About </a>
            </li>
            <li>
              <a href="https://inscribe.ai/privacy"> Privacy </a>
            </li>
            <li>
              <span
                class="manage-cookies-btn cc-revoke"
                @click="openCookiePopup()"
              >
                Manage Cookies
              </span>
            </li>
            <li>
              <a href="https://inscribe.ai/"> &copy; InscribeAI, Inc. </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <notifications group="general" position="top right" />
  </div>
</template>

<script>
import cookieConsentManager from '@/utils/cookieConsentManager';
import LogoComponent from '../V2/Logo';

export default {
  components: {
    'logo-component': LogoComponent,
  },
  methods: {
    openCookiePopup: () => {
      cookieConsentManager.open();
    },
  },
};
</script>

<style lang="scss">
.auth {
  background-color: $color-off-white;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  nav {
    color: rgba(0, 0, 0, 0.9);
    padding: 72px 0 48px;
  }

  section {
    margin-bottom: 48px;
  }

  .view-container {
    background: $color-white;
    border-radius: 8px;
    box-shadow: 0px 4px 10px #e5e5e5;
    max-width: 475px;
    padding: 64px;
  }

  h2 {
    margin-bottom: 32px;
    text-align: center;
  }

  button.btn,
  a.btn {
    margin-top: 6px;
    width: 100%;
  }

  button.btn[disabled] {
    background-color: $color-navy-blue-40;
    border-color: $color-navy-blue-40;
  }

  .footnote {
    margin-top: 16px;
    text-align: center;
  }

  ul.footer-links {
    list-style: none;
    padding: 0;
    margin-bottom: 32px;
    text-align: center;
  }

  .footer-links li {
    display: inline-block;
    margin: auto 6px;
    position: relative;

    .manage-cookies-btn {
      color: $color-dark-blue-80;
      cursor: pointer;
    }
  }

  .footer-links li:not(:first-of-type):before {
    color: $color-raven;
    content: '|';
    font-size: 13px;
    position: absolute;
    left: -8px;
    top: 1px;
  }
}

.blocks-bg {
  bottom: 0;
  left: 0;
  position: fixed;
  width: 100vw;
  z-index: 0;
}
</style>
